import EstimaInput from './estima-input';

type RangeInputProps = {
  from?: number;
  to?: number;
  onChangeFrom?: (arg: number | string) => void;
  onChangeTo?: (arg: number | string) => void;
  inputClass?: string;
  disabledTo?: boolean;
  disabledFrom?: boolean;
  autoPreFix?: boolean;
  delimiter?: string;
};
export type RangePropsChange = {
  to?: number;
  from?: number;
};

const RangeInput = ({
  from,
  to,
  onChangeFrom = () => {},
  onChangeTo = () => {},
  inputClass,
  disabledTo,
  disabledFrom,
  autoPreFix,
  delimiter,
}: RangeInputProps) => {
  return (
    <div className="flex items-center">
      <EstimaInput
        type="number"
        value={from}
        onChangeInput={(value: string | number) => onChangeFrom(value)}
        name="from"
        disabled={disabledFrom}
        autoPreFix={autoPreFix}
        className={`border min-h-[40px] rounded-[3px] w-[110px] ${inputClass}`}
      />
      <span className="mx-2">{delimiter}</span>
      <EstimaInput
        type="number"
        name="to"
        onChangeInput={(value: string | number) => onChangeTo(value)}
        value={to}
        autoPreFix={autoPreFix}
        disabled={disabledTo}
        className={`border min-h-[40px] rounded-[3px] w-[110px] ${inputClass}`}
      />
    </div>
  );
};

export default RangeInput;
